import { toastUtils } from "../../utils/toast-utils";
import { t } from "../../ui/core/translate";
import { getCurrentRoute } from "../router/selectors";
import {
  FETCH_GROUPS_FAILURE,
  FETCH_ADOPTIONS_FAILURE,
  FETCH_ASSETS_FAILURE,
  ACTIVATE_ASSET_FAILURE,
  FETCH_SESSION_FAILURE,
  FETCH_SINGLE_ASSET_FAILURE
} from "../bridge/types";

/**
 * Middleware that will intercept any bridge errors and handle it gracefully
 */
export default store => next => action => {
  const bridgeFailures = [
    FETCH_GROUPS_FAILURE,
    FETCH_ADOPTIONS_FAILURE,
    FETCH_ASSETS_FAILURE,
    ACTIVATE_ASSET_FAILURE,
    FETCH_SESSION_FAILURE,
    FETCH_SINGLE_ASSET_FAILURE
  ];

  if (bridgeFailures.indexOf(action.type) !== -1) {
    const { hash } = getCurrentRoute(store.getState());
    if (hash === "#/classes") {
      toastUtils.notify(t("messages.classes-unavailable"), {
        type: "error"
      });
    } else if (hash === "#/explore" || hash.indexOf("#/activate/") === 0) {
      toastUtils.notify(t("messages.subscriptions-error"), {
        type: "error"
      });
    }
  }

  next(action);
};
